import './App.css';
import React from 'react';

import Home from './pages/Home';
import { Routes, Route} from 'react-router-dom';
import About from './pages/About';
import Career from './pages/Career';
import Clients_Zone from './pages/Clients_Zone';
import Candidate from './pages/Candidate';
import Manpower_Sourcing from './pages/Manpower_Sourcing';
import Performance_Management from './pages/Performance_Management';
import Corporate_Grooming_Programs from './pages/Corporate_Grooming_Programs ';
import Company_Policy_Development from './pages/Company_Policy_Development';
import Employee_training from './pages/Employee_training';
import KRAs_KPIs from './pages/KRAs_KPIs';
import NBFCs from './pages/NBFCs';
import Real_State_Sector from './pages/Real_State_Sector';
import Pharmaceutical from './pages/Pharmaceutical';
import DSA from './pages/DSA';
import It from './pages/It';
import Viewoppingcareer from './pages/Viewoppingcareer';
function App() {

  return (
    <div className='App'>
           <Routes>
          <Route path="/" element={<Home/>}/>
          <Route path="/About" element={<About/>}/>
          <Route path="/Career" element={<Career/>}/>
          <Route path="/Clients_Zone" element={<Clients_Zone/>}/>
          <Route path="/Candidate" element={<Candidate/>}/>
          <Route path="/Manpower_Sourcing" element={<Manpower_Sourcing/>}/>
          <Route path="/Performance_Management" element={<Performance_Management/>}/>
          <Route path="/Corporate_Grooming_Programs" element={<Corporate_Grooming_Programs/>}/>
          <Route path="/Company_Policy_Development" element={<Company_Policy_Development/>}/>
          <Route path="/Employee_training" element={<Employee_training/>}/>
          <Route path="/KRAs_KPIs" element={<KRAs_KPIs/>}/>
          <Route path='/Information-Technology' element={<It/>}/>
          <Route path='/NBFCs'element={<NBFCs/>}/>
          <Route path='/Real_State_Sector'element={<Real_State_Sector/>}/>
          <Route path='/Pharmaceutical'element={<Pharmaceutical/>}/>
          <Route path='/DSA'element={<DSA/>}/>

           <Route path='/Viewoppingcareer'element={<Viewoppingcareer/>}/>
          
         
     

        </Routes>
        

    </div>
  );
}

export default App;
